import type { Action } from 'state/actions';
import { addOrReplaceKey, patchKey } from 'state/utils/collection';

import type { AstroClientMap } from './astroClient.model';
import { initialAstroClient } from './astroClient.model';

export function clientReducer(state: AstroClientMap = initialAstroClient, action: Action): AstroClientMap {
  switch (action.type) {
    case 'SECONDARY_MARKET_REFERENTIAL_ASTRO_CLIENT_REQUESTED':
      return addOrReplaceKey(state, action.clientId, { status: 'pending' as const });
    case 'SECONDARY_MARKET_REFERENTIAL_ASTRO_CLIENT_FETCHED':
      return addOrReplaceKey(state, action.clientId, {
        id: action.clientId,
        custodians: action.custodians,
        status: 'success',
      });

    case 'SECONDARY_MARKET_REFERENTIAL_ASTRO_CLIENT_FETCH_FAILED':
      return patchKey(state, action.clientId, () => ({ status: 'error' as const }));

    case 'SECONDARY_MARKET_REFERENTIAL_ASTRO_CLIENT_FETCH_NOT_FOUND':
      return patchKey(state, action.clientId, () => ({ status: 'not_found' as const }));

    default:
      return state;
  }
}
